
export enum SparkEnum {
  BrokenDefend = 'broken_defend',
  CriticalHit = 'critical_hit',
  SilentCriticalHit = 'silent_critical_hit',
  DefendHit = 'defend_hit',
  Hit = 'hit',
  HitFall = 'hit_fall',
  SilentHit = 'silent_hit',
  Bleed = 'bleed',
  BleedFall = 'bleed_fall',
  CriticalBleed = 'critical_bleed'
}
export const SparkEnumDescriptions: Record<SparkEnum, string> = {
  [SparkEnum.BrokenDefend]: "",
  [SparkEnum.CriticalHit]: "",
  [SparkEnum.SilentCriticalHit]: "",
  [SparkEnum.DefendHit]: "",
  [SparkEnum.Hit]: "",
  [SparkEnum.HitFall]: "",
  [SparkEnum.SilentHit]: "",
  [SparkEnum.Bleed]: "",
  [SparkEnum.BleedFall]: "",
  [SparkEnum.CriticalBleed]: "",
}
